import type { Features } from '@onhandtech/onhand-fe-shared/lib/contracts/config/features'
import { overrideConfigFeaturesWithCookies } from '@onhandtech/onhand-fe-shared/lib/features'
import type { FeatureNames } from 'contracts/config/features'
import { call, put } from 'redux-saga/effects'

import { getConfig } from '../../../config/configuration'
import { setFeatures } from '../actions'

export function* setFeaturesSaga() {
  const { features } = getConfig()

  const newFeatures: Features<FeatureNames> = yield call(
    overrideConfigFeaturesWithCookies,
    features,
  )

  yield put(setFeatures(newFeatures))
}
